
<script>
import request from "./request.vue";
import session from "./session.vue";
import env from "../config/prod.env.js";

export default {

  getReleases: async function(code = '', fromdate='', todate='', model='',  page = 0, limit = 0) {
    // data.split(' ').join('%20');
    try {
      const resp =  await request.send(`${env.ROOT_API}/part_launches/customsearch?code=${code}&fromdate=${fromdate}&todate=${todate}&model=${model}&page=${page}&limit=${limit}`, {}, false, 'get');
      return resp.data;
    } catch (error) {
      console.log(error)
    }
  },

  getLatestReleases: async function(limit = 10) {
    // data.split(' ').join('%20');
    try {
      const resp =  await request.send(`${env.ROOT_API}/part_launches?filter[limit]=${limit}&filter[order]=launch_date DESC`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getManufacturers: async function() {
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicle_manufacturers?filter[order]=name ASC`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getModels: async function(manufacturer){
    try {
      const resp =  await request.send(` ${env.ROOT_API}/vehicles/retrievemodel?manufid=${manufacturer}`, {}, false, 'get');
      return resp.data;
    } catch (error) {
      console.log(error)
    }
  }
};
</script>






// WEBPACK FOOTER //
// src/api/release.vue